// extracted by mini-css-extract-plugin
module.exports = {"starsLink":"_5a76986"};